import { render, staticRenderFns } from "./EventReportView.vue?vue&type=template&id=bdfb2a2a&scoped=true"
import script from "./EventReportView.vue?vue&type=script&lang=ts"
export * from "./EventReportView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfb2a2a",
  null
  
)

export default component.exports